<table width="1650px">                       
    <tr>
        <td width="20%" class="a-col edit-indicator" style="padding-left: 0;" (click)="openAssetMapEdit('ITO Estate')">
            <div class="p3-across-header backround-primary">ITO Estate</div>
            
            <div class="p3-area-holder area-holder-border">                            
                
                <div class="backround-accent p3-table-header">Asset Overview</div>
                <table class="p3-table">
                    <tr>
                        <th width="50%">End User</th>
                        <th width="50%">Amount</th>
                    </tr>
                    <tr>
                        <td>End User Devices</td>
                        <td class="center">{{getAMapValue('enduserdevices')}}</td>
                    </tr>
                </table>
                
                <table class="p3-table" style="margin-top: 10px;">
                    <tr>
                        <th width="50%">Server (Count of OS)</th>
                        <th width="50%">Amount</th>
                    </tr>
                    <tr><td>AIX/IBM Power</td><td class="center">{{getAMapValue('aix_count')}}</td></tr>
                    <tr><td>HPUX</td><td class="center">{{getAMapValue('hp_count')}}</td></tr>
                    <tr><td>Linux (All vendors)</td><td class="center">{{getAMapValue('linux_count')}}</td></tr>
                    <tr><td>Solaris</td><td class="center">{{getAMapValue('solaris_count')}}</td></tr>
                    <tr><td>Windows</td><td class="center">{{getAMapValue('windows_count')}}</td></tr>
                    <tr><td>ESXi Hosts</td><td class="center">{{getAMapValue('esxi_count')}}</td></tr>
                    <tr><td>Containers</td><td class="center">{{getAMapValue('containers_count')}}</td></tr>
                    <tr class="p3-total"><td>Total</td><td class="center">{{getAMapTotalValue('total_count',['aix_count','hp_count','linux_count','solaris_count','windows_count','esxi_count','containers_count'])}}</td></tr>
                </table>

                <table class="p3-table" style="margin-top: 10px;">
                    <tr>
                        <th width="25%">Storage</th>
                        <th width="25%"># Assets</th>
                        <th width="25%">Capacity (TB)</th>
                        <th width="25%">Consumed</th>
                    </tr>

                    <tr><td>Storage</td><td class="center">{{getAMapValue('storage_assets')}}</td><td class="center">{{getAMapValue('storage_capacity')}}</td><td class="center">{{getAMapValue('storage_consumed')}}</td></tr>
                    <tr><td>Backup</td><td class="center">{{getAMapValue('backup_assets')}}</td><td class="center">{{getAMapValue('backup_capacity')}}</td><td class="center">{{getAMapValue('backup_consumed')}}</td></tr>
                    <tr class="p3-total"><td>Total</td><td class="center">{{getAMapTotalValue('total_assets',['storage_assets','backup_assets'])}}</td><td class="center">{{getAMapTotalValue('total_capacity',['storage_capacity','backup_capacity'])}}</td><td class="center">{{getAMapTotalValue('total_consumed',['storage_consumed','backup_consumed'])}}</td></tr>
                </table>
            
            <div class="backround-accent p3-table-header" style="margin-top:30px">DC vs Remote</div>
            <table class="p3-table">
                <tr>
                    <th width="50%">Total Assets per Locations</th>
                    <th width="25%">DC</th>
                    <th width="25%">Remote</th>
                </tr>
                <tr>
                    <td>Servers</td>
                    <td class="center">{{getAMapValue('servers_dc')}}</td>
                    <td class="center">{{getAMapValue('servers_remote')}}</td>                                        
                </tr>
                <tr>
                    <td>Storage (TB)</td>
                    <td class="center">{{getAMapValue('storage_dc')}}</td>
                    <td class="center">{{getAMapValue('storage_remote')}}</td>                                        
                </tr>
            </table>

            <div class="backround-accent p3-table-header" style="margin-top:30px">Locations</div>
            <table class="p3-table">
                <tr>
                    <th width="50%">Locations</th>
                    <th width="50%">Amount</th>
                </tr>
                <tr><td>DCs</td><td class="center">{{getAMapValue('l_dc_amount')}}</td></tr>
                <tr><td>Hubs</td><td class="center">{{getAMapValue('l_hubs_amount')}}</td></tr>
                <tr><td>Server Rooms</td><td class="center">{{getAMapValue('l_serverrooms_amount')}}</td></tr>
                <tr class="p3-total"><td>Total</td><td class="center">{{getAMapTotalValue('l_total_amount',['l_dc_amount','l_hubs_amount','l_serverrooms_amount'])}}</td></tr>
            </table>                                
        </div>

        </td>
        <td width="20%" class="a-col edit-indicator" (click)="openAssetMapEdit('EOL & Managed Estate')">
            <div class="p3-across-header backround-primary">EOL - Operating Systems</div>
            
            <div class="p3-area-holder area-holder-border">                            
                                                    
                <table class="p3-table">
                    <tr>
                        <th width="40%">OS</th>
                        <th width="20%">FY 21</th>
                        <th width="20%">FY 22</th>
                        <th width="20%">FY 23</th>
                    </tr>
                    <tr><td>Linux</td><td class="center">{{getAMapValue('eolos_linux_fy21')}}</td><td class="center">{{getAMapValue('eolos_linux_fy22')}}</td><td class="center">{{getAMapValue('eolos_linux_fy23')}}</td></tr>
                    <tr><td>Windows (Server)</td><td class="center">{{getAMapValue('eolos_windowsserver_fy21')}}</td><td class="center">{{getAMapValue('eolos_windowsserver_fy22')}}</td><td class="center">{{getAMapValue('eolos_windowsserver_fy23')}}</td></tr>
                    <tr><td>Windows (Desktop)</td><td class="center">{{getAMapValue('eolos_windowsdesktop_fy21')}}</td><td class="center">{{getAMapValue('eolos_windowsdesktop_fy22')}}</td><td class="center">{{getAMapValue('eolos_windowsdesktop_fy23')}}</td></tr>
                    <tr><td>Unix (incl AIX / Solaris)</td><td class="center">{{getAMapValue('eolos_unix_fy21')}}</td><td class="center">{{getAMapValue('eolos_unix_fy22')}}</td><td class="center">{{getAMapValue('eolos_unix_fy23')}}</td></tr>
                    <tr><td>ESXi</td><td class="center">{{getAMapValue('eolos_esxi_fy21')}}</td><td class="center">{{getAMapValue('eolos_esxi_fy22')}}</td><td class="center">{{getAMapValue('eolos_esxi_fy23')}}</td></tr>
                    <tr><td>Network Gear</td><td class="center">{{getAMapValue('eolos_network_fy21')}}</td><td class="center">{{getAMapValue('eolos_network_fy22')}}</td><td class="center">{{getAMapValue('eolos_network_fy23')}}</td></tr>
                    
                    <tr class="p3-total"><td>Total</td><td class="center">{{getAMapTotalValue('eolos_total_fy21',['eolos_linux_fy21','eolos_windowsserver_fy21','eolos_windowsdesktop_fy21','eolos_unix_fy21','eolos_esxi_fy21','eolos_network_fy21'])}}</td>
                        <td class="center">{{getAMapTotalValue('eolos_total_fy22',['eolos_linux_fy22','eolos_windowsserver_fy22','eolos_windowsdesktop_fy22','eolos_unix_fy22','eolos_esxi_fy22','eolos_network_fy22'])}}</td>
                        <td class="center">{{getAMapTotalValue('eolos_total_fy23',['eolos_linux_fy23','eolos_windowsserver_fy23','eolos_windowsdesktop_fy23','eolos_unix_fy23','eolos_esxi_fy23','eolos_network_fy23'])}}</td></tr>
                </table>
            
            </div>

            <div class="p3-across-header backround-primary">EOL - Hardware</div>
            
            <div class="p3-area-holder area-holder-border">                            
                                                    
                <table class="p3-table">
                    <tr>
                        <th width="40%">EOL</th>
                        <th width="20%">FY 21</th>
                        <th width="20%">FY 22</th>
                        <th width="20%">FY 23</th>
                    </tr>
                    <tr><td>End User Devices</td><td class="center">{{getAMapValue('eol_eud_fy21')}}</td><td class="center">{{getAMapValue('eol_eud_fy22')}}</td><td class="center">{{getAMapValue('eol_eud_fy23')}}</td></tr>
                    <tr><td>Servers</td><td class="center">{{getAMapValue('eol_servers_fy21')}}</td><td class="center">{{getAMapValue('eol_servers_fy22')}}</td><td class="center">{{getAMapValue('eol_servers_fy23')}}</td></tr>
                    <tr><td>Storage</td><td class="center">{{getAMapValue('eol_storage_fy21')}}</td><td class="center">{{getAMapValue('eol_storage_fy22')}}</td><td class="center">{{getAMapValue('eol_storage_fy23')}}</td></tr>
                    <tr><td>Network</td><td class="center">{{getAMapValue('eol_network_fy21')}}</td><td class="center">{{getAMapValue('eol_network_fy22')}}</td><td class="center">{{getAMapValue('eol_network_fy23')}}</td></tr>
                    <tr class="p3-total"><td>Total</td><td class="center">{{getAMapTotalValue('eol_total_fy21',['eol_eud_fy21','eol_servers_fy21','eol_storage_fy21','eol_network_fy21'])}}</td>
                        <td class="center">{{getAMapTotalValue('eol_total_fy22',['eol_eud_fy22','eol_servers_fy22','eol_storage_fy22','eol_network_fy22'])}}</td>
                        <td class="center">{{getAMapTotalValue('eol_total_fy23',['eol_eud_fy23','eol_servers_fy23','eol_storage_fy23','eol_network_fy23'])}}</td></tr>
                </table>

                <table class="p3-table">
                    <tr>
                        <th width="40%">EOSL</th>
                        <th width="20%">FY 21</th>
                        <th width="20%">FY 22</th>
                        <th width="20%">FY 23</th>
                    </tr>
                    <tr><td>End User Devices</td><td class="center">{{getAMapValue('eosl_eud_fy21')}}</td><td class="center">{{getAMapValue('eosl_eud_fy22')}}</td><td class="center">{{getAMapValue('eosl_eud_fy23')}}</td></tr>
                    <tr><td>Servers</td><td class="center">{{getAMapValue('eosl_servers_fy21')}}</td><td class="center">{{getAMapValue('eosl_servers_fy22')}}</td><td class="center">{{getAMapValue('eosl_servers_fy23')}}</td></tr>
                    <tr><td>Storage</td><td class="center">{{getAMapValue('eosl_storage_fy21')}}</td><td class="center">{{getAMapValue('eosl_storage_fy22')}}</td><td class="center">{{getAMapValue('eosl_storage_fy23')}}</td></tr>
                    <tr><td>Network</td><td class="center">{{getAMapValue('eosl_network_fy21')}}</td><td class="center">{{getAMapValue('eosl_network_fy22')}}</td><td class="center">{{getAMapValue('eosl_network_fy23')}}</td></tr>
                    <tr class="p3-total"><td>Total</td><td class="center">{{getAMapTotalValue('eosl_total_fy21',['eosl_eud_fy21','eosl_storage_fy21','eosl_storage_fy21','eosl_network_fy21'])}}</td>
                        <td class="center">{{getAMapTotalValue('eosl_total_fy22',['eosl_eud_fy22','eosl_storage_fy22','eosl_storage_fy22','eosl_network_fy22'])}}</td>
                        <td class="center">{{getAMapTotalValue('eosl_total_fy23',['eosl_eud_fy23','eosl_storage_fy23','eosl_storage_fy23','eosl_network_fy23'])}}</td></tr>
                </table>                                    
            
            </div>         
            
            <div class="p3-across-header backround-primary">Managed Estate</div>
            
            <div class="p3-area-holder area-holder-border">                            
                                                    
                <table class="p3-table">
                    <tr>
                        <th width="50%">Assets</th>
                        <th width="25%">DXC</th>
                        <th width="25%">Others</th>
                        
                    </tr>
                    <tr><td>Server Physical</td><td class="center">{{getAMapValueDXC('me_serverphysical_dxc')}}</td><td class="center">{{getAMapValueDXC('me_serverphysical_others')}}</td></tr>
                    <tr><td>Servers Virtual / Containers</td><td class="center">{{getAMapValueDXC('me_servervirual_dxc')}}</td><td class="center">{{getAMapValueDXC('me_servervirual_others')}}</td></tr>
                    <tr><td>Cloud Instances</td><td class="center">{{getAMapValueDXC('me_cloud_dxc')}}</td><td class="center">{{getAMapValueDXC('me_cloud_others')}}</td></tr>
                    <tr><td>Storage (TB)</td><td class="center">{{getAMapValueDXC('me_storage_dxc')}}</td><td class="center">{{getAMapValueDXC('me_storage_others')}}</td></tr>
                    <tr><td>Network</td><td class="center">{{getAMapValueDXC('me_network_dxc')}}</td><td class="center">{{getAMapValueDXC('me_network_others')}}</td></tr>
                    
                </table>                               
            
            </div>  
        
        <td width="20%" class="a-col edit-indicator" (click)="openAssetMapEdit('Service Management & Cloud Estate')">

            <div class="p3-across-header backround-primary">Service Management</div>
            
            <div class="p3-area-holder area-holder-border">                            
                
                <div class="backround-accent p3-table-header">Operations (Staff)</div>
                <table class="p3-table">
                    <tr>
                        <th width="50%">Server</th>
                        <th width="50%"># of FTE</th>
                    </tr>
                    <tr><td>Server Operations</td><td class="center">{{getAMapValue('fte_serveroperations')}}</td></tr>
                    <tr><td>Storage/Backup/Network Ops</td><td class="center">{{getAMapValue('fte_storage')}}</td></tr>
                    <tr><td>Architecture/Design</td><td class="center">{{getAMapValue('fte_arch')}}</td></tr>
                    <tr><td>Security</td><td class="center">{{getAMapValue('fte_security')}}</td></tr>
                    <tr><td>Project Services</td><td class="center">{{getAMapValue('fte_project')}}</td></tr>
                    <tr><td>Reporting/Risk/Cross Func</td><td class="center">{{getAMapValue('fte_reporting')}}</td></tr>
                    <tr><td>Acct Management/BusOps</td><td class="center">{{getAMapValue('fte_acctmngnt')}}</td></tr>
                    <tr class="p3-total"><td>Total</td><td class="center">{{getAMapTotalValue('fte_total',['fte_serveroperations','fte_storage','fte_arch','fte_security','fte_project','fte_reporting','fte_acctmngnt'])}}</td></tr>
                </table>
                
            
            <div class="backround-accent p3-table-header" style="margin-top:20px">P1's Raised</div>
            <table class="p3-table">
                <tr>
                    <th width="50%">Year</th>
                    <th width="50%">Amount</th>
                </tr>
                <tr><td>2019</td><td class="center">{{getAMapValueDXC('p1_2019')}}</td></tr>
                <tr><td>2020</td><td class="center">{{getAMapValueDXC('p1_2020')}}</td></tr>
            </table>
                                          
        </div>

            <div class="p3-across-header backround-primary" style="margin-top:68px">Cloud Estate</div>
            
            <div class="p3-area-holder area-holder-border">                            
                
                <table class="p3-table" style="margin:20px 0 20px 0">
                    <tr><td>Active Cloud Strategy</td><td class="p3-total center">{{getAMapValueDXC('cloud_activecloudstrategy')}}</td></tr>
                </table>
                
                <table class="p3-table">
                    <tr>
                        <th width="50%">Description</th>
                        <th width="50%">Amount / Instances</th>
                    </tr>
                    <tr><td>Azure</td><td class="center">{{getAMapValue('cloud_azure')}}</td></tr>
                    <tr><td>AWS</td><td class="center">{{getAMapValue('cloud_aws')}}</td></tr>
                    <tr><td>GCP</td><td class="center">{{getAMapValue('cloud_gcp')}}</td></tr>
                    <tr><td>MPC / Other</td><td class="center">{{getAMapValue('cloud_mpc')}}</td></tr>
                    <tr><td>Traditional DC / Remote</td><td class="center">{{getAMapValue('cloud_traditional')}}</td></tr>
                    <tr class="p3-total"><td>Total</td><td class="center">{{getAMapTotalValue('cloud_total',['cloud_azure','cloud_aws','cloud_gcp','cloud_mpc','cloud_traditional'])}}</td></tr>
                </table>
                                                                         
        </div>

        </td>
        <td width="30%" class="a-col">
            <div class="edit-indicator" (click)="openAssetMapEdit('MB & Design Review & HW Buyout')">
            <div class="p3-across-header backround-primary">MB $ Opportunity</div>
            
            <div class="p3-area-holder area-holder-border">                            
            
                <table class="p3-table">
                    <tr>
                        <th width="32%">Partner</th>
                        <th width="34%">Amount</th>
                        <th width="34%">When</th>
                    </tr>
                    <tr><td>Dell/EMC</td><td class="center">{{getAMapValueDXC('mb_dell_amount')}}</td><td class="center">{{getAMapValueDXC('mb_dell_when')}}</td></tr>
                    <tr><td>HPE</td><td class="center">{{getAMapValueDXC('mb_hpe_amount')}}</td><td class="center">{{getAMapValueDXC('mb_hpe_when')}}</td></tr>
                    <tr><td>Pure</td><td class="center">{{getAMapValueDXC('mb_pure_amount')}}</td><td class="center">{{getAMapValueDXC('mb_pure_when')}}</td></tr>
                    <tr><td>Other</td><td class="center">{{getAMapValueDXC('mb_other_amount')}}</td><td class="center">{{getAMapValueDXC('mb_other_when')}}</td></tr>
                    <tr class="p3-total"><td>Total</td><td class="center">{{getAMapTotalValueDXC('mb_total_amount',['mb_dell_amount','mb_hpe_amount','mb_pure_amount','mb_other_amount'])}}</td>
                        <td class="center"></td></tr>
                </table>
                                                                                                      
            </div>

            <div class="p3-across-header backround-primary">Design Review</div>
            
            <div class="p3-area-holder area-holder-border">                            
            
                <table class="p3-table">
                    <tr>
                        <th width="32%">Domain</th>
                        <th width="34%">Status</th>
                        <th width="34%">Which Partner</th>
                    </tr>
                    <tr><td>Cloud/Server</td><td class="center">{{getAMapValueDXC('dr_cloud_status')}}</td><td class="center">{{getAMapValueDXC('dr_cloud_partner')}}</td></tr>
                    <tr><td>Storage</td><td class="center">{{getAMapValueDXC('dr_storage_status')}}</td><td class="center">{{getAMapValueDXC('dr_storage_partner')}}</td></tr>
                    <tr><td>Network</td><td class="center">{{getAMapValueDXC('dr_network_status')}}</td><td class="center">{{getAMapValueDXC('dr_network_partner')}}</td></tr>
                    <tr><td>Workplace</td><td class="center">{{getAMapValueDXC('dr_workplace_status')}}</td><td class="center">{{getAMapValueDXC('dr_workplace_partner')}}</td></tr>                                        
                </table>
                                                                                                      
            </div>

            <div class="p3-across-header backround-primary">HW - Buyout Values</div>
            
            <div class="p3-area-holder area-holder-border">                            
            
                <table class="p3-table">
                    <tr>
                        <th width="40%">Buyout value in M$</th>
                        <th width="15%">FY21</th>
                        <th width="15%">FY22</th>
                        <th width="15%">FY23</th>
                        <th width="15%">FY24</th>
                        
                    </tr>
                    <tr><td>Server Assets</td><td class="center">{{getAMapValueDXC('bo_server_fy21')}}</td><td class="center">{{getAMapValueDXC('bo_server_fy22')}}</td><td class="center">{{getAMapValueDXC('bo_server_fy23')}}</td><td class="center">{{getAMapValueDXC('bo_server_fy24')}}</td></tr>
                    <tr><td>Storage & Network Assets</td><td class="center">{{getAMapValueDXC('bo_storage_fy21')}}</td><td class="center">{{getAMapValueDXC('bo_storage_fy22')}}</td><td class="center">{{getAMapValueDXC('bo_storage_fy23')}}</td><td class="center">{{getAMapValueDXC('bo_storage_fy24')}}</td></tr>
                    <tr class="p3-total"><td>Total</td><td class="center">{{getAMapTotalValueDXC('bo_total_fy21',['bo_server_fy21','bo_storage_fy21'])}}</td>
                        <td class="center">{{getAMapTotalValueDXC('bo_total_fy22',['bo_server_fy22','bo_storage_fy22'])}}</td>
                        <td class="center">{{getAMapTotalValueDXC('bo_total_fy23',['bo_server_fy23','bo_storage_fy23'])}}</td>
                        <td class="center">{{getAMapTotalValueDXC('bo_total_fy24',['bo_server_fy24','bo_storage_fy24'])}}</td></tr>
                </table>
                                                                                                      
            </div>     
            </div>
            
            <table width="100%" height="272px" class="edit-indicator" (click)="openAssetMapEdit('Next Steps & Actions')">
                <tr height="40px">
                    <td class="a-label3 aip-primary-color">Next Steps / Actions</td>                                        
                </tr>
                <tr>
                    <td class="a-value4 a-border">
                        <div><div [innerHTML]="getAMapValueDXC('nextstepsactions')"></div></div>                                           
                    </td>                                        
                </tr>
                </table> 

        </td>
    </tr>

</table>